/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import {
  Flex,
  Heading,
  useDisclosure,
  Spinner,
  Box,
  HStack,
  Stack,
  Switch,
  VStack,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import _ from 'lodash';
import { Text } from '@mybridge/ui/text';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import {
  EarthGlobeIcon,
  TeamIcon,
  OnlyMeLockIcon,
  BackArrow,
  ArrowRight,
  CalendarIcon,
  CalendarNewIcon,
} from '@mybridge/icons';
import { AppsAndExtentions } from '@mybridge/icons/AppsAndExtentions';
import { VideoConferencing } from '@mybridge/icons/VideoConferencing';

import { MentionTag } from '@mybridge/icons/MentionTag';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export default function IntegrationForMobile({ setSelectedComponent, setSelectedSubItem }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const toast = useToast();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const userFriendsPermDisc = useDisclosure();
  const userFriendsListPermDisc = useDisclosure();
  const { t } = useTranslator();

  return (
    <AuthenticatedProviders>
      <VStack gap="10px" padding="30px 16px 10px 16px">
     <Box>
          <Heading as="h4" size="md"
           p={'10px'}
           sx={{
            "@media screen and (max-width: 375px)": {
              width: "350px"
            },
            "@media screen and (max-width: 280px)": {
             padding:"6px"
            },
          }}
            border="1px solid #ECECEC"
            borderRadius="30px"
            onClick={()=> {
              setSelectedComponent('calendar-sync');
              setSelectedSubItem('calendar-sync')
            }} 
            >
            <HStack justifyContent="start">
              <CalendarNewIcon width="20" height="20"/>
              <HStack justifyContent="space-between" width="80">
              <Text 
              fontWeight="400" 
              fontSize="16px" 
              lineHeight="19.2px" 
              color="#868585"
              marginLeft="5%"
              sx={{
                "@media screen and (max-width: 375px)": {
                  fontSize: "14px",
                },
                "@media screen and (max-width: 280px)": {
                  fontSize: "10px",
                },
              }}
             
              >
                {t('otherModules.calendar_sync') || "Calendar sync"}
              </Text>
              <ArrowRight/>
              </HStack>
            </HStack>
          </Heading>
        </Box>
        <Box>
          <Heading as="h4" size="md"
           p={'10px'}
           sx={{
            "@media screen and (max-width: 375px)": {
              width: "350px"
            },
            "@media screen and (max-width: 280px)": {
             padding:"6px"
            },
          }}
            border="1px solid #ECECEC"
            borderRadius="30px"
            onClick={()=> {
              setSelectedComponent('video-conferencing');;
              setSelectedSubItem('video-conferencing')
            }} 
            >
            <HStack justifyContent="start">
              <VideoConferencing/>
              <HStack justifyContent="space-between" width="80">
              <Text 
              fontWeight="400" 
              fontSize="16px" 
              lineHeight="19.2px" 
              color="#868585"
              marginLeft="5%"
              sx={{
                "@media screen and (max-width: 375px)": {
                  fontSize: "14px",
                },
                "@media screen and (max-width: 280px)": {
                  fontSize: "10px",
                },
              }}
             
              >
                {t('myCalendar.videoConferencing') || "Video conferencing"}
              </Text>
              <ArrowRight/>
              </HStack>
            </HStack>
          </Heading>
        </Box>
        <Box>
          <Heading as="h4" size="md"
           p={'10px'}
           sx={{
            "@media screen and (max-width: 375px)": {
              width: "350px"
            },
            "@media screen and (max-width: 280px)": {
             padding:"6px"
            },
          }}
            border="1px solid #ECECEC"
            borderRadius="30px"
            onClick={()=> {
              setSelectedComponent('app-extenstions')}} 
            >
            <HStack justifyContent="start">
              <AppsAndExtentions/>
              <HStack justifyContent="space-between" width="80">
              <Text 
              fontWeight="400" 
              fontSize="16px" 
              lineHeight="19.2px" 
              color="#868585"
              marginLeft="5%"
              sx={{
                "@media screen and (max-width: 375px)": {
                  fontSize: "14px",
                },
                "@media screen and (max-width: 280px)": {
                  fontSize: "10px",
                },
              }}
             
              >
                {t('otherModules.apps_extensions') || "Apps & Extensions"}
              </Text>
              <ArrowRight/>
              </HStack>
            </HStack>
          </Heading>
        </Box>
        </VStack>
    </AuthenticatedProviders>
  );
}
